import script from "./ReviewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsPage.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsPage.vue?vue&type=style&index=0&id=1871b8c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1871b8c2"]])

export default __exports__